import React from 'react';
import './AboutSection.css';

const AboutSection = () => {
  return (
    <div className="about-section">
      <div className="about-container">
        <div className="about-image">
          <img src="/images/ailen2.png" alt="Ailen" />
        </div>
        <div className="about-content">
          <h2>Ailen en pocas palabras</h2>
          <p>
            Comencé mi viaje dando clases particulares en 2017 y desde entonces, mi pasión por enseñar no ha hecho más que crecer. Me llena de alegría ver a mis estudiantes progresar y alcanzar sus metas. Además, he descubierto que el aprendizaje es un proceso de doble vía: he ganado valiosos conocimientos de mis alumnos. A menudo me describen como una profesora lúdica y didáctica, que atiende a las necesidades e intereses específicos de cada estudiante.
          </p>
          <p>
            Para cada nuevo alumno, es fundamental entender sus preferencias y objetivos con el idioma. Reconozco que cada estudiante es único, con diferentes estilos de aprendizaje y metas, por lo que adapto mis clases a ellos. Esto implica el uso de diversos materiales, desde presentaciones en Prezi, PowerPoint y Canva, hasta videos, tráilers de películas, podcasts, lecturas en línea e incluso juegos que ayudan a aprender inglés.
          </p>
          <p>
            A partir de mi experiencia personal como estudiante de inglés, puedo empatizar con los desafíos que enfrentan mis alumnos. Esta comprensión moldea la manera en que conduzco mis lecciones, asegurando que sean tan efectivas y de apoyo como hubiera querido cuando era estudiante.
          </p>
          <p>
            Estoy certificada en TEFL y tuve la enriquecedora experiencia de vivir como estudiante de intercambio en Estados Unidos y el Reino Unido durante seis meses. El año pasado completé mi pasantía en el Colegio Internacional SEK, enseñando a estudiantes de primaria y secundaria, específicamente a alumnos de 1°, 3°, 4° y 8° grado. Me gradué en Pedagogía en Inglés en enero de 2024 con las mejores notas.
          </p>
          <p>
            ¡Vamos a embarcarnos juntos en este viaje lingüístico! Recuerda: "Un idioma diferente es una visión diferente de la vida."
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutSection;
